export default "__VITE_ASSET__b6cd38e8__"